<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <HeaderSubModality
      @edit="showModalEditModality"
      @new="showModalNewSubModality"
      @filter="updateFilter"
    />
    <SubModalityTable @edit="showModalEditSubModality" :filter="filter" />
    <ModalModality
      @close="closeModal"
      v-model="modal"
      v-if="modal"
      @submit="submit"
      :is-edit="edit"
      :has-historic="historic"
      :list="listHistoric"
      :title="title"
      :form="form"
      :type-item="typeItem"
      :submodality="submodality"
    />
  </Main>
</template>
<script>
import HeaderSubModality from "../components/HeaderSubModality";
import SubModalityTable from "../components/SubModalityTable";
import ModalModality from "../components/ModalModality";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
export default {
  data: () => ({
    historic: false,
    listHistoric: [],
    edit: false,
    modal: false,
    form: {},
    title: null,
    filter: null,
    typeItem: null,
    submodality: null
  }),
  components: {
    HeaderSubModality,
    SubModalityTable,
    ModalModality
  },
  created() {
    this.fetchSubModality();
  },
  mixins: [LoadingRequest],
  computed: {
    ...mapState("modality", ["currentModality"]),
    ...mapState("me", ["myInfo"]),
    breadcrumb() {
      const { nome } = this.currentModality || { nome: "" };
      return [
        {
          text: `MODALIDADE: ${nome}`,
          to: "economic_group view"
        }
      ];
    }
  },
  methods: {
    ...mapActions("modality", [
      "requestSubModality",
      "requestCurrentModality",
      "requestPostSubModality",
      "requestPutSubModality",
      "requestPutModality",
      "requestUploadIcon"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    fetchSubModality() {
      this.withLoading(
        Promise.all([
          this.requestSubModality(this.$route.params.id),
          this.requestCurrentModality(this.$route.params.id)
        ])
      );
    },
    putSubModality() {
      this.withLoading(
        this.requestPutSubModality(this.getPayload(this.form)).then(() => {
          this.showAlertNotification({
            message: "Sub Modalidade editada com sucesso.",
            type: "success"
          });
        })
      );
    },
    postSubModality() {
      this.withLoading(
        this.requestPostSubModality(this.getPayload(this.form)).then(() => {
          this.showAlertNotification({
            message: "Sub Modalidade criada com sucesso.",
            type: "success"
          });
        })
      );
    },
    putModality() {
      this.withLoading(
        this.requestPutModality(this.getPayload(this.form)).then(() => {
          this.showAlertNotification({
            message: "Modalidade editada com sucesso.",
            type: "success"
          });
        })
      );
    },
    previousPage() {
      this.$router.push({ name: "list modality" });
    },
    getPayload(form) {
      form.area = this.myInfo.area_usuario;
      return {
        idModality: this.$route.params.id,
        idSubModality: form.id || null,
        value: form
      };
    },
    async submit() {
      this.modal = false;
      if (this.form.imagem != null && !this.form.imagem.url) {
        this.form.imagem = await this.withLoading(
          await this.requestUploadIcon(
            this.getUploadFilePayload(this.form.imagem)
          )
        );
      }
      (this.operation == "post-sub-modality" && this.postSubModality()) ||
        (this.operation == "put-sub-modality" && this.putSubModality()) ||
        (this.operation == "put-modality" && this.putModality());
    },
    showModalEditSubModality(item) {
      this.form = _.cloneDeep(item);
      this.operation = "put-sub-modality";
      this.title = "EDITAR SUB-MODALIDADE";
      this.edit = true;
      this.modal = true;
      this.typeItem = "sub-modalidade";
      this.submodality = true;
    },
    showModalNewSubModality() {
      this.form = {
        nome: null,
        ativo: true,
        tooltip: null
      };
      this.operation = "post-sub-modality";
      this.title = "ADICIONAR SUB-MODALIDADE";
      this.edit = false;
      this.modal = true;
      this.typeItem = "sub-modalidade";
      this.submodality = true;
    },
    showModalEditModality(item) {
      this.form = _.cloneDeep(item);
      this.operation = "put-modality";
      this.title = "EDITAR MODALIDADE";
      this.edit = true;
      this.modal = true;
      this.typeItem = "modalidade";
      this.submodality = false;
    },
    closeModal() {
      this.modal = false;
    },
    updateFilter(value) {
      this.filter = value;
    }
  }
};
</script>
